"use client"

import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import OfertouLogo from "../../assets/logo-homepage.svg";
import Footer from "../../components/Footer";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-color: #e9e2db;
  font-family: 'Roboto', sans-serif;
  overflow-x: hidden;
`;

const NotFound = () => {
  return (
    <Container>
      <main className="flex-grow flex flex-col">
        {/* Header */}
        <header className="bg-[#e9e2db] py-5 px-4 sm:px-6 md:px-12 lg:px-24 w-full sticky top-0 z-50">
          <div className="flex items-center justify-between max-w-[1400px] mx-auto">
            <a href="/" className="mr-8">
              <img src={OfertouLogo} alt="Ofertou Logo" width={130} height={45} className="h-10 w-auto" />
            </a>
            <nav className="hidden md:flex space-x-12">
              <a href="/app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
                Ofertas
              </a>
              <a
                href="/#como-funciona"
                className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors"
              >
                Como Funciona
              </a>
              <a href="https://espera.ofertou.app" className="text-[#212121] hover:text-[#eb6813] font-medium text-base lg:text-lg transition-colors">
                Divulgar produtos
              </a>
            </nav>
            <div className="md:hidden flex items-center">
              <button className="p-2 text-[#212121]">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              </button>
            </div>
          </div>
        </header>

        {/* Error Content */}
        <div className="flex-grow flex flex-col items-center justify-center px-4 py-16 sm:py-24">
          <div className="text-center max-w-md mx-auto">
            <h1 className="text-9xl font-bold text-[#eb6813]">404</h1>
            <h2 className="mt-6 text-3xl font-bold text-[#212121]">Página não encontrada</h2>
            <p className="mt-4 text-lg text-gray-600">
              Desculpe, não conseguimos encontrar a página que você está procurando.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#eb6813] hover:bg-[#d25700] transition-colors"
              >
                Voltar para a página inicial
              </Link>
              <Link
                to="/app"
                className="inline-flex items-center justify-center px-6 py-3 border border-[#eb6813] text-base font-medium rounded-md text-[#eb6813] bg-transparent hover:bg-[#eb6813] hover:text-white transition-colors"
              >
                Ver ofertas
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </Container>
  );
};

export default NotFound;
